(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recs"] && !window.DesignMode) return;
  try {
    

    function loadFlkty() {
      var elem = document.querySelector('.carousel');
      var flkty = new Flickity( elem, {
          groupCells: false, 
          freeScroll: true,
          wrapAround: true
      });

      // element argument can be a selector string
      //   for an individual element
      var flkty = new Flickity( '.carousel', {
          
      });

      console.log("test");
    }  

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
  
      observer.unobserve(productRecommendationsSection);
  
      const url = productRecommendationsSection.dataset.url;
  
      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-recommendations-alc');
  
          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
          }
        }).then(() => {
          loadFlkty();
        })
        .catch(e => {
          console.error(e);
        });
    };
  
    const productRecommendationsSection = document.querySelector('.product-recommendations-alc');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
  
    observer.observe(productRecommendationsSection);

    
    


    
  
  } catch(e) { console.error(e); }
})();
})();
